import { FeaturedProjects } from "@ecologi/react-components/src/FeaturedProjects";

export default FeaturedProjects;
